import { render, staticRenderFns } from "./HomeMenu.vue?vue&type=template&id=ab2331f2"
import script from "./HomeMenu.vue?vue&type=script&lang=js"
export * from "./HomeMenu.vue?vue&type=script&lang=js"
import style0 from "./HomeMenu.vue?vue&type=style&index=0&id=ab2331f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports